<template>
  <v-container grid-list-xl>
    <v-layout row justify-center align-center wrap class="mt-4 pt-2">
      <v-flex v-for="portfolio in portfolios" :key="portfolio.src" xs12 sm12 md4 lg4 xl4>
        <v-card
          :href="portfolio.url"
          hover
          flat
          color="transparent"
          target="_blank"
          height="230"
        >
          <v-card-title></v-card-title>
          <v-img :src="portfolio.src" aspect-ratio="2.75" height="130" contain></v-img>
          <v-card-title primary-title class="justify-center">
            <v-flex text-xs-center subheading font-weight-bold>{{portfolio.title}}</v-flex>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  metaInfo: {
    title: "SungheeWoo",
    titleTemplate: "%s-Portfolio",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "Portfolio"
      },
      { charset: "utf-8" },
      { property: "og:title", content: "Sugnhee' Space" },
      { property: "og:site_name", content: "Sugnhee' Space" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://Sugnhee.space" },
      {
        property: "og:image",
        content: "https://i.imgur.com/Dcz2PGx.jpg"
      },
      {
        property: "og:description",
        content:
          "Portfolio"
      }
    ]
  },
  data() {
    return {
      portfolios: [
        // {
        //   src: "https://s3.us-west-1.amazonaws.com/sungheewoo.com/img/logo_ai_mind_tr.png",
        //   title: "Generative AI - app",
        //   url: "http://ai-mind-post-flutter.s3-website-us-west-1.amazonaws.com/"
        // },

        {
          src: "https://s3.us-west-1.amazonaws.com/newz4ai.com/img/logo.png",
          title: "Latest News RAG LLM",
          url: "https://www.newz4ai.com"
        },

        {
          src: "https://s3.us-west-1.amazonaws.com/sungheewoo.com/img/logo_flutter_tr.png",
          title: "Flutter front-end",
          url: "http://flutter-portfolio-website.s3-website-us-west-1.amazonaws.com/"
        },

        {
          src: "https://s3.us-west-1.amazonaws.com/sungheewoo.com/img/logo_html.png",
          title: "HTML/JS front-end",
          url: "http://html-css-js-portfolio-website.s3-website-us-west-1.amazonaws.com/"
        },
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
</style>